import { render, staticRenderFns } from "./DeptEdit.vue?vue&type=template&id=033dda14&scoped=true"
import script from "./DeptEdit.vue?vue&type=script&lang=js"
export * from "./DeptEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033dda14",
  null
  
)

export default component.exports